<template>
  <f7-page
    name="farmers"
    class="main-farmerspage"
    @page:reinit="pageReinit"
  >
    <template #fixed>
      <TheNavbar
        :nav-title="$t('common.farmers')"
        back-btn-enable
        :style="appTheme"
      >
        <template #right>
          <f7-link
            v-if="statusSyncs"
            href="/settings/syncContracts/"
          >
            <img
              :src="iconSync"
            >
          </f7-link>
          <f7-link
            class="margin-right-half"
            href="/new-farmer-wizzard/"
          >
            <img
              :src="iconNewFarmer"
            >
          </f7-link>
        </template>
      </TheNavbar>
    </template>

    <div class="padding-horizontal-half padding-vertical-half bg-blue-Contracts search-component">
      <UCSearch
        :placeholder="$t('BuscaAgricultorFincaCultivo')"
        :min-length="3"
        @change="filterFarmersData"
      />
    </div>
    <UCPreload :show="showPreload" />
    <UCEmptyList
      v-if="farmerLastQuery === ''"
      :icon="iconSearch"
      title="Busca un agricultor, finca o cultivo"
      subtitle="Introduce un texto para buscar"
    />
    <div
      v-if="farmerLastQuery !== '' && farmerCount !== 0"
      class="padding content-results-counter bg-blue-Contracts"
    >
      {{ `${$t('Hay')} ${farmerCount} ${$t('resultadosPara')}` }}
      <b>{{ ` "${farmerLastQuery}"` }}</b>
    </div>
    <UCEmptyList
      v-if="farmerLastQuery !== '' && farmerCount === 0"
      :icon="iconSearch"
      title="Sin resultados de busqueda"
      :subtitle="`No se han encontrado resultados para el criterio ${farmerLastQuery}` "
    />
    <UCAcordeon
      :items="filteredData"
      class="sorted-accordion-list toggle-color-accordion-list"
      :show-badge="false"
      primary="var(--his-slate-blue)"
      font-color="#fff"
      :show-item-border-bottom="true"
      border-item-bottom-color="#E5EEF7"
      group-items
      group-key="farmer"
      chevron-side="left"
      :closed="true"
      :opened-index="0"
    >
      <template #titleOption="{ option }">
        {{ option.items[0].farmer }}
      </template>

      <template #after="{ item }">
        <img
          :src="iconDetail"
          @click="clickFarmerRow($event, item)"
        >
      </template>

      <template #subOption="{ item }">
        <HiInfoRow
          v-if="item.field != null"
          :title="item.field"
          :title-count="item.crops.length"
        >
          <template #after>
            <img
              :src="(item.contracts.length === 0) ? iconContractOff : (item.contracts.filter((c) => c.state === 1).length > 0) ? iconContractPending : iconContractValidated"
              height="30"
              width="30"
              @click="goToContracts(item.id)"
            >
            <!-- <img
              :src="iconCreateCrop"
              @click="clickNewCrop(item)"
            > -->
            <img
              :src="iconEdit"
              height="30"
              width="30"
              @click="clickEditField(item.id)"
            >
          </template>
        </HiInfoRow>

        <NoFieldsInfo v-else>
          No hay fincas
        </NoFieldsInfo>
        <div v-if="item.field == null || item.crops.length > 0">
          <f7-list media-list>
            <f7-list-item
              v-for="crop
                in
                  item.crops"
              :key="crop.id"
              :title="crop.varietyName"
              :text="crop.name"
              class="padding-right-half"
            >
              <template #after>
                <div>
                  <img
                    :src="iconEdit"
                    height="30"
                    width="30"
                    @click="clickEditCrop(crop)"
                  >
                </div>
              </template>
            </f7-list-item>
          </f7-list>
        </div>
        <NoCropsInfo v-else />
      </template>
    </UCAcordeon>
    <FieldActionSheet
      :opened="fieldActionSheetOpened"
      :field="selectedField"
      @delete-field="pageReinit"
      @sheet:close="fieldActionSheetOpened = false"
      @create-contract="createContractForField"
    />

    <CropActionSheet
      :opened="cropActionSheetOpened"
      :crop="selectedCrop"
      @delete-crop="pageReinit"
      @sheet:close="cropActionSheetOpened = false"
    />
  </f7-page>
</template>

<script>
import TheNavbar from '@/components/TheNavbar.vue';
import UCPreload from '@/components/common/UCPreload.vue';
import UCAcordeon from '@/components/common/UCAcordeon.vue';
import HiInfoRow from '@/components/common/HiInfoRow.vue';
import UCSearch from '@/components/common/UCSearch.vue';
import UCEmptyList from '@/components/common/UCEmptyList.vue';
import icSearch from '@/static/icons/ic_shape.svg';
import icEdit from '@/static/img/ic_editc.svg';
import icFarmer from '@/static/img/ic_farmer.svg';
import icDetail from '@/static/img/ic_detail.svg';
import icContractOff from '@/static/img/ic_contract_off.svg';
import icContractPending from '@/static/img/ic_contract_pending.svg';
import FarmerService from '@/js/services/contracts/Farmers';
import FieldService from '@/js/services/contracts/Fields';
import icSync from '@/static/img/ic_refresh_error.svg';
import SyncData from '@/js/services/contracts/SyncData';
import icContractValidated from '@/static/img/ic_button_contratos.svg';
import FieldActionSheet from '@/components/contracts/FieldActionSheet.vue';
import CropActionSheet from '@/components/contracts/CropActionSheet.vue';
import NoFieldsInfo from '@/components/contracts/NoFieldsInfo.vue';
import NoCropsInfo from '@/components/contracts/NoCropsInfo.vue';
import { nextTick } from 'vue';
import { f7 } from 'framework7-vue';

export default {
  name: 'FarmersPage',
  components: {
    TheNavbar,
    UCAcordeon,
    HiInfoRow,
    FieldActionSheet,
    CropActionSheet,
    NoFieldsInfo,
    NoCropsInfo,
    UCSearch,
    UCPreload,
    UCEmptyList,

  },

  data() {
    return {
      filteredData: [],
      fieldActionSheetOpened: false,
      cropActionSheetOpened: false,
      selectedField: {},
      selectedCrop: {},
      farmersData: [],
      showPreload: false,
      statusSyncs: false,
      farmerLastQuery: '',
    };
  },

  computed: {
    appTheme() {
      return {
        '--f7-navbar-bg-color': 'var(--his-dark-blue)',
        '--f7-navbar-text-color': '#fff',
      };
    },

    farmerCount() {
      const farmerIds = this.filteredData.map((f) => f.farmerId);
      const unique = [...new Set(farmerIds)];
      return unique.length;
    },
    iconEdit() {
      return icEdit;
    },
    iconDetail() {
      return icDetail;
    },
    iconSearch() {
      return icSearch;
    },
    iconNewFarmer() {
      return icFarmer;
    },
    iconContractOff: () => icContractOff,
    iconContractPending: () => icContractPending,
    iconContractValidated: () => icContractValidated,
    iconSync: () => icSync,
  },

  async created() {
    await this.getFarmersData(true);
    if (this.farmerLastQuery !== '') {
      this.filterFarmersData(this.farmerLastQuery);
    }
  },

  async mounted() {
    this.pageReinit();
  },

  methods: {
    async getFarmersData(showPreload) {
      if (showPreload) {
        f7.preloader.show();
      }
      const farmers = await FarmerService.getFarmersFullInfo();
      this.parseFarmerData(farmers);
      if (showPreload) {
        f7.preloader.hide();
      }
    },
    async clickEditField(fieldId) {
      const field = await FieldService.getById(fieldId);
      this.selectedField = field;
      this.fieldActionSheetOpened = true;
    },
    clickEditCrop(crop) {
      this.selectedCrop = crop;
      this.cropActionSheetOpened = true;
    },
    /*
    searchBarChanged(event) {

      // this.filterFarmersData(event.target.value.toLowerCase());
      this.currentQuery = event.target.value.toLowerCase();
    },
    */
    clickFarmerRow(event, farmer) {
      event.stopPropagation();
      event.preventDefault();

      f7.views.main.router.navigate(`/farmers/${farmer.items[0].farmerId}`);
    },

    filterFarmersData(query) {
      this.farmerLastQuery = query.toLowerCase();
      if (query.toLowerCase() === '') {
        this.filteredData = []; return;
      }
      this.showPreload = true;
      const auxData = [...this.farmersData];

      // TODO revisar si se puede hacer en un sólo paso, y no con el map y luego con filter || HACER CON FOREACH
      this.filteredData = auxData.map((farmer) => {
        const auxFarmer = { ...farmer };
        if (auxFarmer.farmer.toString().toLowerCase().includes(query.toLowerCase())
          || (auxFarmer.field != null && auxFarmer.field.toString().toLowerCase().includes(query.toLowerCase()))) {
          return auxFarmer;
        }

        auxFarmer.crops = auxFarmer.crops.filter((crop) => crop.varietyName.toString().toLowerCase().includes(query.toLowerCase()));
        if (auxFarmer.crops.length > 0) {
          return auxFarmer;
        }

        return null;
      });

      this.filteredData = this.filteredData.filter((farmer) => farmer != null);
      // f7.preloader.hide();
      this.showPreload = false;
    },
    // we will make a line per field, so the sorted accordion can properly group by farmer
    parseFarmerData(farmers) {
      const parsedData = [];
      farmers.forEach((farmer) => {
        if (farmer.fields.length > 0) {
          farmer.fields.forEach((field) => {
            parsedData.push({
              id: field.id,
              farmer: `${farmer.id} - Nombre: ${farmer.name} - Código: ${farmer.code} - Empresa: ${farmer.CompanyProvider.business}`,
              farmerId: farmer.id,
              farmerCode: farmer.code,
              crops: field.crops,
              contracts: field.contracts,
              field: field.name,
              business: farmer.CompanyProvider.business,
            });
          });
        } else {
          parsedData.push({
            id: -1,
            farmer: `${farmer.id} - Nombre: ${farmer.name} - Código: ${farmer.code} - Empresa: ${farmer.CompanyProvider.business}`,
            farmerId: farmer.id,
            farmerCode: farmer.code,
            crops: [],
            field: null,
            business: farmer.CompanyProvider.business,
          });
        }
      });
      this.farmersData = parsedData;
      // this.filteredData = parsedData;
    },

    async pageReinit() {
      this.statusSyncs = await this.getStatusSyncs();
      nextTick(async () => { // we do this to avoid reloading component when its not in the view, we do that on page reinit
        if (f7.views.main.router.currentRoute.route.component.name === 'FarmersPage') {
          await this.getFarmersData(false);
          if (this.farmerLastQuery !== '') {
            this.filterFarmersData(this.farmerLastQuery);
          }
        }
      });
    },
    async getStatusSyncs() {
      return SyncData.GetStatusSync();
    },
    createContractForField(field) {
      this.fieldActionSheetOpened = false;
      f7.views.main.router.navigate('/new-contract/', {
        props: {
          fieldId: Number.parseInt(field.id, 10),
        },
      });
    },

    goToContracts(id) {
      f7.views.main.router.navigate('/contracts/', {
        props: {
          fieldId: Number.parseInt(id, 10),
        },
      });
    },
  },
};
</script>

<style lang="scss">
.main-farmerspage {
  .page-content {
    background: var(--his-whispering-lilac);
  }

  .content-results-counter {
    color: var(--his-silver);
    font-weight: 400;
    margin-top: -1px;
  }

  .list .item-title {
    color: var(--his-dark-blue);
  }

  .list .item-link .item-inner {
    padding-right: 10px;
  }

  .main-info-row {
    background-color: var(--his-silver) !important;

    &::after {
      border-top-color: var(--his-silver) !important;
    }

    .item-title {
      color: var(--his-dark-blue);
      font-weight: 500;
    }

    .list {
      .content-checkbox {
        background: var(--his-soft-blue);

        .item-content {
          .item-inner {
            span {
              background: var(--his-oliva);
            }
          }
        }
      }
    }
  }

  .accordion-item {
    .item-inner {
      .item-content {
        .item-title {
          color: var(--his-light-blue);
        }
      }
    }
  }

  @media (max-width: 820px) {
    .accordion-item {
      .item-inner {
        .item-content {
          .item-title {
            color: var(--his-light-blue);
            height: 50px;
          }
        }

        .item-after {
          height: 70px;
        }
      }
    }
  }

  .storybook-action-sorted-accordion {
    .accordion-list {
      .sorted-accordion {
        .item-after {
          img:nth-child(2) {
            filter: unset;
          }
        }
      }
    }
  }
}
</style>
